<template>
  <div>
    <div class="systemSetting-box">
      <ul>
        <li class="clearfix">
          <div class="li-title">系统名称：</div>
          <div class="li-content">
            <el-input v-model="systemInfo.name" placeholder="请输入"></el-input>
          </div>
        </li>
        <li class="clearfix">
          <div class="li-title">系统logo：</div>
          <div class="li-content">
            <el-upload
              ref='upload'
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadFiles"
              accept="image/jpeg,image/gif,image/png"
              action=''
              :before-upload="beforeAvatarUpload">
              <img v-if="systemInfo.imageUrl" :src="systemInfo.imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="tishi tishi-top">支持JPG、JPEG、PNG格式的图片，图片最大为1M</p>
            <p class="tishi">标准尺寸为：40px*40px</p>
          </div>
        </li>
      </ul>
      <a @click="saveFun()" class="select-box-btn">保 存</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'SystemSettings',
  data () {
  	return {
      userInfo:JSON.parse(localStorage.getItem('UserInfo')),
      systemInfo:{
        name:'',
        imageUrl:''
      }
  	}
  },
  mounted () {
    var _this=this;
    if(_this.userInfo.systemName){
      _this.systemInfo.name=_this.userInfo.systemName;
    };
    if(_this.userInfo.systemLogo){
      _this.systemInfo.imageUrl=_this.userInfo.systemLogo;
    };
    // console.log(JSON.stringify(_this.userInfo))
  },
  methods:{
    beforeAvatarUpload(file) {
      // console.log(file)
      const isJPG=/^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error('上传图片为 JPG、JPEG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    },
    uploadFiles: function(options) {
      var file = options.file;
      var filename = file.name;
      var reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file)
      }
      reader.onload = () => {
        var base64Str = reader.result;
        base64Str = base64Str.split(',')[1]
        var sendData= new Object();
        sendData.imgBase64=base64Str;
        this.$axios.post("/requestApi/system/upload/img",sendData)
        .then(res => {
          if(res.data.code==200){
            this.systemInfo.imageUrl=res.data.data;
            this.$message({
              type: 'success',
              message: '上传成功！'
            });
          }else{
            this.$message({
              message: data.message,
              type: 'warning'
            });
          }            
        })
        .catch(err => {
          console.log(err)
        })
      }
    },
    //保存
    saveFun:function(){
      var _this=this;
      var sendData=new Object();
      if(_this.systemInfo.imageUrl==''){
        _this.$message("请输入上传系统logo");
      }else if(_this.systemInfo.name==''){
        _this.$message("请输入系统名称");
      }else{
        sendData.systemLogo=_this.systemInfo.imageUrl;
        sendData.systemName=_this.systemInfo.name;
        sendData.userId=_this.userInfo.id;
        _this.$axios.post('/requestApi/system/add/edit',sendData)      
          .then(function(response){
            let data = response.data;
            if(data.meta.retCode==0){
              _this.$message({
                message: '保存成功!请重新登录查看',
                type: 'success'
              });
            }else{
              _this.$message({
                message: data.meta.friendlyMsg,
                type: 'warning'
              });
            }
          })
          .catch(function(error){
            console.log(error)
          });
      }
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.systemSetting-box{width: 500px;margin: 0 auto; margin-top: 100px;box-shadow: 0 0 4px rgba(0,0,0,0.1);padding: 30px;background-color: #fff;}
.systemSetting-box li{width: 100%; margin-top: 20px;}
.systemSetting-box li .li-title{width: 20%;float: left;text-align: right;line-height: 30px;}
.systemSetting-box li .li-content{width: 80%;float: right;}
.tishi-top{margin-top: 10px;}
.tishi{font-size: 12px;line-height: 16px;color: #666;}
.select-box-btn{margin: 0 auto;margin-top: 60px;}
</style>



// WEBPACK FOOTER //
// src/components/SystemSettings.vue